// extracted by mini-css-extract-plugin
export var indeterminate = "_2d-6";
export var md = "_2d-5";
export var semantic = "_2d-7";
export var sm = "_2d-4";
export var text = "_2d-8";
export var toggleControl = "_2d-0";
export var toggleInput = "_2d-1";
export var toggleSwitch = "_2d-2";
export var xs = "_2d-3";